import React, { Component } from "react";
import { connect } from "react-redux";
var $ = window.$ || {}

class ActivityList extends Component {

closeList = () => {
    $('.activity_list_popup').addClass('d-none');
    $('.header').removeClass('zindex999');
}

showVideo = (url) => {
  var video = document.getElementById('video_script');
  video.setAttribute("src", url);
  window.$('#script-video-popup').modal('show');
  $('#ac_list_pop').addClass('blur_activity');
  $(".modal-backdrop").hide();

  video.onloadedmetadata = function ()
  {
      video.play();
  }
}

render() {

  let currentUserData = JSON.parse(localStorage.getItem('userData'));
  let sessionScript = [];
  
  if (currentUserData != null) 
  {
	sessionScript = currentUserData.sessionData.scriptDetail;
  }
  

  window['hideActivityScript'] = hideScript;
  function hideScript(index){
    setTimeout( () => {
	    $('#activity-swiper-slide'+(index-1)).remove();
	}, 100);
  }

  return (

      <div className="activity_list_popup d-none" id="ac_list_pop">
        <div className="acitvity_close_button" onClick={this.closeList.bind(this)}></div>
            <div className="activity_list_title">Activities</div>
			<div className="activity_list_border"></div>
			{ sessionScript && sessionScript.length > 0 &&
				<div className="activity_list_flex">
					{
					  sessionScript.map((opt, i) =>
						<div className="row text-white script-list" key={i} id={"activity-swiper-slide"+i}>
							<div className="operation_title">{opt.name}</div>
							<div className="activity_section_hold">
								<div className="activityTimingHold">
									{opt.attribute.map(function(attrb, index){ if(attrb.attrLabel == 'counter'){
										return <div className="ac_list_counter ac_list_counter_active" data-number={attrb.attrValue} key={index}>{attrb.attrValue}</div>;
									} }, this)}
									
									{opt.attribute.map(function(attrb, index){
									if(attrb.attrLabel.toLowerCase() == 'duration' && attrb.attrLabel != '') {
										return <div className="ac_list_description_active">{attrb.attrValue === 'Time' ? 'Seconds' : attrb.attrValue}</div>;
									} }, this)}
								</div>
								
								{opt.attribute.map(function(attrb, index){
									if(attrb.attrLabel.toLowerCase() == 'video' && attrb.attrValue != '' && attrb.attrValue != 'NA') {
										return <div className="activity_list_video" key={index}><img src="images/play_activity.svg" onClick={this.showVideo.bind(this, encodeURI(attrb.attrValue))} /></div>;
									}

									if(attrb.attrLabel == 'Activity Type' && (attrb.attrValue.toLowerCase() == 'pause' || attrb.attrValue.toLowerCase() == 'pause virtual') && currentUserData.userType == 2){
										window['hideActivityScript'](i+1)
									}
								}, this)}
							</div>
						</div>
					)}
				</div>
			}
        </div>      
    );
  }
}

export default ActivityList;